<template>
  <div class="multi-rich-text-container">
    <div class="multi-rich-text-title">{{ data?.title }}</div>
    <ul>
      <li v-for="(item, index) in data?.data.contents" :key="index">
        <div class="multi-rich-text-item-title-container" @click="toggleItem(index)">
          <span class="multi-rich-text-item-title">{{ item.title }}</span>
          <div class="multi-rich-text-item-icon"
               :style="item.is_open ? {backgroundColor:'#D1806D'} : {backgroundColor:'#1F2E51'}">
            {{ item.is_open ? '-' : '+' }}
          </div>
        </div>
        <!-- 展开内容 -->
        <transition name="slide-fade">
          <div v-show="item.is_open" class="multi-toggle-content">
            <div class="multi-rich-text" v-html="item?.content"></div>
          </div>
        </transition>
      </li>
    </ul>
  </div>
</template>

<script setup>

const props = defineProps({
  jsonData: Object
})

const data = reactive(props.jsonData)

// 切换列表项的展开/收起状态
const toggleItem = (index) => {
  data.data.contents[index].is_open = !data.data.contents[index].is_open;
}

</script>
<script>
export default {
  name: 'MultiRichTextView'
}
</script>

<style lang="less">
.multi-rich-text-container {
  width: 100%;

  .multi-rich-text-title {
    font-size: 20px;
    color: var(--main-color);
    letter-spacing: 2px;
    font-weight: bold;
  }

  ul {
    padding: 0;
    list-style: none;
    margin-top: 30px;

    li {
      margin-bottom: 32px;

      .multi-rich-text-item-title-container {
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding: 8px;
        align-items: center;
        background-color: #F2F2F2;
        border-radius: 30px;
        cursor: pointer;

        .multi-rich-text-item-title {
          font-size: 16px;
          color: var(--main-color);
          margin-left: 20px;
        }

        .multi-rich-text-item-icon {
          width: 38px;
          height: 38px;
          border-radius: 38px;
          font-size: 26px;
          color: #FFFFFF;
          text-align: center;
          user-select: none;
        }

        &:hover {
          opacity: 0.7;
        }
      }

      .multi-toggle-content {
        padding: 24px 36px 0 36px;

        .multi-rich-text {

          p span {
            line-height: 2 !important;
            font-size: 16px !important;
            letter-spacing: 1px !important;
            color: var(--font-color) !important;
          }

          h6 {
            margin-top: 10px !important;
            margin-bottom: 10px !important;

            span {
              font-size: 14px !important;
              letter-spacing: 1px !important;
              font-weight: normal !important;
              color: rgba(127, 127, 127) !important;
            }
          }

          h5 {
            margin-top: 10px !important;
            margin-bottom: 10px !important;

            span {
              font-size: 16px !important;
              letter-spacing: 1px !important;
              font-weight: bold !important;
              color: var(--main-color) !important;
            }
          }

          p video {
            margin-bottom: 10px !important;
          }

          p span strong {
            line-height: 3 !important;
            font-size: 18px !important;
            color: var(--main-color) !important;
            letter-spacing: 1px !important;
          }

          p span strong span {
            line-height: 3 !important;
            font-size: 18px !important;
            color: var(--main-color) !important;
            letter-spacing: 1px !important;
          }

          p strong span {
            line-height: 3 !important;
            font-size: 18px !important;
            color: var(--main-color) !important;
            letter-spacing: 1px !important;
          }

          p span img {
            margin-top: 20px !important;
            margin-bottom: 20px !important;
          }

          p img {
            margin-top: 20px !important;
            margin-bottom: 20px !important;
          }

          td img {
            margin-top: 20px !important;
            margin-bottom: 20px !important;
          }
        }
      }

      .slide-fade-enter-active, .slide-fade-leave-active {
        transition: transform 0.5s ease, opacity 0.5s ease;
      }

      .slide-fade-enter, .slide-fade-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
        transform: translateY(-20px);
        opacity: 0;
      }
    }
  }
}
</style>